import styles from "./assets/css/HeroSection.module.css";
import heroVideo from "./assets/video/hero_video.mp4";
import scrollIconMouse from "./assets/img/mouse_icon.webp";
import scrollIconArrows from "./assets/img/down_arrows.webp";
import scrollIconFinger from "./assets/img/finger_Icon.svg";

const HeroSection = () => {
  return (
    <section className={styles.heroContainer}>
      <video
        src={heroVideo}
        controls={false}
        className={styles.video}
        playsInline={true}
        muted
        loop
        autoPlay
      />
      <h1 className={styles.title}>Our Precision. Your Advantage.</h1>
      <a href={"#welcome"} className={styles.scrollIconContainer}>
        <img
          className={styles.scrollIconMouse}
          src={scrollIconMouse}
          alt=""
          width={37}
          height={58}
        />
        <img
          className={styles.scrollIconArrows}
          src={scrollIconArrows}
          alt=""
          width={23}
          height={24}
        />
        <img
          className={styles.scrollIconFinger}
          src={scrollIconFinger}
          alt=""
          width={23}
          height={24}
        />
      </a>
    </section>
  );
};
export default HeroSection;
